import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from '@mui/material';
import { PortsEditor } from '../components/PortsEditor';

export function renderPortsEditor(field, cell, theme, graph, paper, inspector) {
  const container = document.createElement('div');
  const existingPorts = cell.getPorts() || [];

  const handleUpdatePorts = (newPorts) => {
    if (field.readOnly) return;
    const oldPorts = cell.get('ports/items') || [];
    if (JSON.stringify(oldPorts) === JSON.stringify(newPorts)) return;

    cell.prop('ports/items', newPorts, {
      rewrite: true,
      ui: true,
      track: true,
      inspector: false,
    });

    const cellView = cell.findView(paper);
    if (cellView) cellView.render();

    requestAnimationFrame(() => inspector?.render());
  };

  ReactDOM.render(
    <ThemeProvider theme={theme}>
      <PortsEditor
        portsData={existingPorts}
        graph={graph}
        paper={paper}
        cell={cell}
        cellId={cell.id}
        updateValue={handleUpdatePorts}
        readOnly={field.readOnly}
      />
    </ThemeProvider>,
    container
  );

  return container;
}
